<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>运营管理</el-breadcrumb-item>
            <el-breadcrumb-item>敏感词管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="请输入敏感词" clearable v-model="queryInfo.word" @clear="getList()" style="width: 300px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.category" clearable placeholder="分类" @change="getList()" style="margin-left: 10px">
                        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.level" clearable placeholder="敏感级别" @change="getList()" style="margin-left: 10px">
                        <el-option label="禁止提交" :value="1"></el-option>
                        <el-option label="替换" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.status" clearable placeholder="状态" @change="getList()" style="margin-left: 10px">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-plus" style="margin-left: 10px" @click="openDialog()" v-permission="'btn:operations:sensitivewords:add'">新增</el-button>
                </el-col>
            </el-row>
            <br>
            <el-table :data="list" :key="list.index" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="敏感词" prop="word" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="分类" width="120">
                    <template slot-scope="scope">
                        {{ getCategoryLabel(scope.row.category) }}
                    </template>
                </el-table-column>
                <el-table-column label="敏感级别" width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.level == 1" type="danger">禁止提交</el-tag>
                        <el-tag v-else type="warning">替换</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="替换词" prop="replaceWord" width="120"></el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
                        <el-tag v-else type="info">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="175"></el-table-column>
                <el-table-column label="更新时间" prop="updateTime" width="175"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="openDialog(scope.row)" v-permission="'btn:operations:sensitivewords:edit'"></el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)" v-permission="'btn:operations:sensitivewords:delete'"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNum" :page-sizes="[20,50,500,1000]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
            <el-form ref="formRef" :model="form" :rules="dialogFormRules" label-width="100px">
                <el-form-item label="敏感词" prop="word">
                    <el-input v-model="form.word" placeholder="请输入敏感词" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="分类" prop="category">
                    <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
                        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="敏感级别" prop="level">
                    <el-select v-model="form.level" placeholder="请选择敏感级别" style="width: 100%" @change="onLevelChange">
                        <el-option label="禁止提交" :value="1"></el-option>
                        <el-option label="替换" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.level == 2" label="替换词" prop="replaceWord">
                    <el-input v-model="form.replaceWord" placeholder="请输入替换词" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="form.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="btnLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            queryInfo: {
                word: '',
                category: '',
                level: '',
                status: '',
                pageNum: 1,
                pageSize: 20
            },
            categoryOptions: [
                { label: '政治', value: '1' },
                { label: '色情', value: '2' },
                { label: '暴力', value: '3' },
                { label: '广告', value: '4' }
            ],
            total: 0,
            list: [],
            admin_token: '',
            dialogVisible: false,
            dialogTitle: '新增敏感词',
            btnLoading: false,
            form: {
                id: null,
                word: '',
                category: '',
                level: 1,
                replaceWord: '',
                status: 1
            },
            formRules: {
                word: [
                    { required: true, message: '请输入敏感词', trigger: 'blur' }
                ],
                category: [
                    { required: true, message: '请选择分类', trigger: 'change' }
                ],
                level: [
                    { required: true, message: '请选择敏感级别', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        dialogFormRules() {
            const rules = { ...this.formRules }
            if (this.form.level === 2) {
                rules.replaceWord = [
                    { required: true, message: '请输入替换词', trigger: 'blur' }
                ]
            }
            return rules
        }
    },
    created() {
        this.admin_token = window.sessionStorage.getItem('admin_token')
        this.getList()
    },
    methods: {
        getCategoryLabel(value) {
            const item = this.categoryOptions.find(v => v.value === String(value))
            return item ? item.label : value
        },
        async getList() {
            const { data: res } = await this.$http.get('sensitivewordslist/', { params: this.queryInfo })
            if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
            }
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize
            this.getList()
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage
            this.getList()
        },
        onLevelChange(level) {
            if (level !== 2) {
                this.form.replaceWord = ''
            }
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate('replaceWord')
                }
            })
        },
        openDialog(row) {
            if (row) {
                this.dialogTitle = '编辑敏感词'
                this.form = {
                    id: row.id,
                    word: row.word,
                    category: row.category,
                    level: row.level,
                    replaceWord: row.replaceWord || '',
                    status: row.status
                }
            } else {
                this.dialogTitle = '新增敏感词'
                this.form = {
                    id: null,
                    word: '',
                    category: '',
                    level: 1,
                    replaceWord: '',
                    status: 1
                }
            }
            this.dialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate()
                }
            })
        },
        async submitForm() {
            const valid = await this.$refs.formRef.validate().catch(() => false)
            if (!valid) {
                return
            }

            this.btnLoading = true
            try {
                const payload = {
                    id: this.form.id,
                    word: this.form.word.trim(),
                    category: this.form.category,
                    level: this.form.level,
                    replaceWord: this.form.level == 2 ? this.form.replaceWord.trim() : '',
                    status: this.form.status
                }
                const url = this.form.id ? 'sensitivewordsedit/' : 'sensitivewordsadd/'
                const { data: res } = await this.$http.post(url, payload)

                if (res.code === 0) {
                    this.$message.success(res.msg || '操作成功')
                    this.dialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (error) {
                this.$message.error('请求失败，请稍后重试')
            } finally {
                this.btnLoading = false
            }
        },
        async DelInfo(id) {
            const confirmResult = await this.$confirm('是否要删除此敏感词?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已取消删除！')
            }
            const { data: res } = await this.$http.get('sensitivewordsdel/' + id)
            if (res.code === 0) {
                this.$message({ message: res.msg || '删除成功！', type: 'success' })
            } else {
                this.$message.error(res.msg || '删除失败')
            }
            this.getList()
        }
    }
}
</script>
